import React, {useEffect, useMemo, useState} from 'react'
import styles from './UIGameHelpChatLogsButton.module.scss'
// eslint-disable-next-line no-restricted-imports
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage} from '@colonist/types'
import clsx from 'clsx'
import {useUIGameStateContext} from '../../../contexts/UIGameStateContext'
import {useUIGamePauseContext} from '../../UIGamePause/UIGamePauseContext'
import {useUIGameUserSettingsContext} from '../../../contexts/UIGameUserSettingsContext'

interface ButtonProps {
    image: LobbyImage.Chat | LobbyImage.Log
    isSelected: boolean
    isBubbleVisible: boolean
    onClick: () => void
}

export const Button = ({
    image,
    isSelected,
    isBubbleVisible,
    onClick,
}: ButtonProps) => (
    <div onClick={onClick}className={clsx(styles.buttonContainer, {
        [styles.selected]: isSelected,
        [styles.bubble]: isBubbleVisible,
    })}>
        <div className={styles.icon}>
            <img src={getLobbyImagePath(image)} />
        </div>
    </div>
)

interface UIGameHelpOpenChatLogsButtonProps {
    onSetChatVisible: (visible: boolean) => void
    onSetLogVisible: (visible: boolean) => void
}

export const UIGameHelpOpenChatLogsButton = ({
    onSetChatVisible,
    onSetLogVisible,
}: UIGameHelpOpenChatLogsButtonProps) => {
    const {gameState} = useUIGameStateContext()
    const [isChatSelected, setIsChatSelected] = useState(false)
    const [isLogSelected, setIsLogSelected] = useState(false)
    const [numberOfReadMessages, setNumberOfReadMessages] = useState(0)
    const numberOfMessages = useMemo(() => Object.keys(gameState.gameChatState).length, [gameState])
    const isChatBubbleVisible = numberOfMessages > numberOfReadMessages

    const {isOpenSettings} = useUIGameUserSettingsContext()
    const {isPaused} = useUIGamePauseContext()

    useEffect(() => {
        if(isOpenSettings === true || isPaused === true) {
            onSetChatVisible(false)
            onSetLogVisible(false)
            setIsChatSelected(false)
            setIsLogSelected(false)
        }
    }, [isOpenSettings, isPaused])

    useEffect(() => {
        if(isChatSelected) {
            setNumberOfReadMessages(numberOfMessages)
        }
    }, [numberOfMessages])

    const handleChatClick = () => {
        const newIsChatSelected = !isChatSelected
        setIsChatSelected(newIsChatSelected)
        setIsLogSelected(false)
        onSetChatVisible(newIsChatSelected)
        setNumberOfReadMessages(numberOfMessages)
    }

    const handleLogClick = () => {
        const newIsLogSelected = !isLogSelected
        setIsLogSelected(newIsLogSelected)
        setIsChatSelected(false)
        onSetLogVisible(newIsLogSelected)
    }

    return (
        <div className={styles.container}>
            <Button image={LobbyImage.Log} isSelected={isLogSelected} isBubbleVisible={false} onClick={handleLogClick} />
            <Button image={LobbyImage.Chat} isSelected={isChatSelected} isBubbleVisible={isChatBubbleVisible} onClick={handleChatClick} />
        </div>
    )
}
